import { IconButton, Panel, Tooltip } from '@ixicare/ui';
import React from 'react';
import { t } from '~/i18n';
import { GenericTable } from '~components/Tables/DeviceTables/GenericTable';
import { BaseTableConfig } from '~components/Tables/DeviceTables/types';

interface DeviceHealthTableProps {
  config: BaseTableConfig;
  rows: any[][];
  status: string;
  orderBy: string;
  ascOrder: boolean;
  handleSort: (columnId: string) => void;
}

export function DeviceHealthTable({ config, rows, status, orderBy, ascOrder, handleSort }: DeviceHealthTableProps) {
  const iconRef = React.useRef<HTMLElement>(null!);
  const localizedStatusKey = status.toLowerCase().replace(/ /g, '_');
  return (
    <>
      <div className={status === 'GREEN' ? `no-print` : ``} key={status}>
        <Tooltip
          title={t(`device-health.status.${localizedStatusKey}.name`)}
          content={t(`device-health.status.${localizedStatusKey}.tooltip`)}
          triggerRef={iconRef}
        >
          <Panel>
            <div className="row">
              <Panel.Title className="col-md-12">
                {t(`device-health.status.${localizedStatusKey}.name`)}
                <IconButton ref={iconRef} icon="question" />
              </Panel.Title>
            </div>
            <GenericTable config={config} rows={rows} orderBy={orderBy} asc={ascOrder} onClickColumn={handleSort} />
          </Panel>
        </Tooltip>
      </div>
    </>
  );
}
